export default __webpack_public_path__ + "static/media/100_74323.7a07e6ec.jpg";